import { BaseSettingAnswer } from '../../../__generated__/graphql';
import CustomizeJsonData from '../@types/CustomizeJsonData';

export function jsonDataFromBaseSettingAnswer(data?: BaseSettingAnswer): CustomizeJsonData {
  return {
    mergedSettingsData: data?.mergedSettingsData ?? '',
    settingsData: data?.settingsData ?? '',
  };
}
